import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function EmailFormatsPage() {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    }
  ];

  const formFields = [
    {
      name: 'id',
      label: 'Email Format ID',
      type: 'textarea',
      placeholder: 'Email Chain ID',
      disabled: true
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'Email Format Name',
      rules: [{ required: true, message: 'Must enter a name for this email format!' }]
    },
    {
      name: 'data',
      label: 'Data',
      type: 'textarea',
      placeholder: 'Email Format Data',
      rules: [{ required: true, message: 'Must enter the body text itself for this email format!' }]
    }
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/email_formats"
        readEndpoint="read/email_formats"
        editEndpoint="update/email_formats"
        deleteEndpoint="delete/email_formats"
       // copyEndpoint="copy/email_chains"
        //addedDataColumn='WebCustomers'
        //addedDataColumnLabel='Customers'
        //addedDataColumnName='name'
        columns={columns}
        formFields={formFields}
        //canCopy={true}
        title="Email Formats"
      />
    </div>
  );
}